import { useAuth } from "@/auth/AuthProvider";
import { ErrorText, SBCard } from "@/components/ui";
import { useActiveLeagueID, useLeagueSnapshot } from "@/features/home/useLeagueSnapshot";
import { PersonRow } from "@/features/home/ListScreens";
import { activeMembership } from "@/models/user";
import { SchemaEditor } from "./SchemaEditor";
import "@/features/home/home.css";
import "@/features/league/league.css";

// Port of LeagueAthletesListView + LeagueAthleteConfigView: roster + schema.

export function LeagueAthleteConfig() {
  const { currentUser } = useAuth();
  const { leagueID } = useActiveLeagueID();
  const snapshot = useLeagueSnapshot(false);
  const sportID = currentUser ? activeMembership(currentUser)?.sportID : undefined;

  if (!leagueID) return <ErrorText>Select a league workspace first.</ErrorText>;

  const athletes = snapshot.memberSummaries.filter((member) => member.roles.includes("athlete"));

  return (
    <div className="list-screen league-screen">
      <div className="list-screen-head">
        <h1>Athlete Data</h1>
      </div>

      <SchemaEditor
        collectionName="leagueAthleteSchemas"
        leagueID={leagueID}
        sportID={sportID}
        title="Athlete profile schema"
        subtitle="Fields every athlete in this league is asked to provide."
      />

      <SBCard className="home-card">
        <div className="home-card-head">
          <h3>League athletes</h3>
          <span className="badge">{athletes.length}</span>
        </div>
        {athletes.map((member) => (
          <PersonRow key={member.id} member={member} />
        ))}
        {athletes.length === 0 && <p className="home-hint">No athletes have joined yet.</p>}
      </SBCard>
    </div>
  );
}

export function LeagueOrgAdminConfig() {
  const { currentUser } = useAuth();
  const { leagueID } = useActiveLeagueID();
  const sportID = currentUser ? activeMembership(currentUser)?.sportID : undefined;

  if (!leagueID) return <ErrorText>Select a league workspace first.</ErrorText>;

  return (
    <div className="list-screen league-screen">
      <div className="list-screen-head">
        <h1>Organization Admins</h1>
      </div>
      <SchemaEditor
        collectionName="leagueOrganizationAdminSchemas"
        leagueID={leagueID}
        sportID={sportID}
        title="Organization admin schema"
        subtitle="Details collected from organization admins when they join."
      />
    </div>
  );
}
